export default {
    methods: {
        URLencode(sStr) {
            if (sStr) {
                return sStr
                    .replace(/\%/g, "%25")
                    .replace(/\+/g, "%2B")
                    .replace(/\"/g, "%22")
                    .replace(/\'/g, "%27")
                    .replace(/\//g, "%2F")
                    .replace(/ /g, "-")
                    .replace(/↵/g, "");
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/URLencode.js